interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  articlePublishedTime,
  articleModifiedTime,
}: SEOHeadProps) {
  const fullTitle = title.includes('蘑菇视频') ? title : `${title} - 蘑菇视频`;
  const fullUrl = `https://www.mogushipin.com${canonicalUrl}`;
  const defaultImage = 'https://readdy.ai/api/search-image?query=A%20modern%20Chinese%20short%20video%20app%20brand%20imagery%20with%20play%20button%20icon%20and%20vibrant%20colors%2C%20warm%20orange%20and%20white%20gradient%20background%2C%20clean%20minimalist%20design&width=1200&height=630&seq=mogu-og-default&orientation=landscape';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '蘑菇视频',
    url: 'https://www.mogushipin.com',
    description: '蘑菇视频是一款备受用户喜爱的短视频娱乐平台，提供海量高清视频内容、流畅播放体验与丰富创作工具。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://www.mogushipin.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={ogImage || defaultImage} />
      <meta property="og:site_name" content="蘑菇视频" />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage || defaultImage} />

      {articlePublishedTime && <meta property="article:published_time" content={articlePublishedTime} />}
      {articleModifiedTime && <meta property="article:modified_time" content={articleModifiedTime} />}

      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </>
  );
}